<template>
<header id="app-header" :class="{menuOpen: menuShown}">
  <div class="container">
    <div class="profile_info">
      <img class="profile_img" src="@/assets/img/PROFILE_PHOTO_c.jpg">
      <div class="profile_desc">
        <h1>Lorenzo Pinna Rodríguez</h1>
        <p>I'm mainly a web developer knowing the latest trends and
          constantly looking forward to learn.
          I define myself as an ambitious, perfectionist person,
          I like to polish every detail in everything I do.
          I'm currently studying but almost everything I've learned has been in a self-tought way.
      </div>
    </div>
    <div class="skills">
      <h2>Skills</h2>
      <div class="skill_container">
        <skill level="100">HTML & CSS</skill>
        <skill level="80">Javascript</skill>
        <skill level="80">PHP</skill>
        <skill level="94">Java</skill>
        <skill level="45">C#</skill>
      </div>
    </div>
  </div>
</header>
</template>

<script>
import Skill from './Skill';

export default {
  name: 'AppHeader',
  components: {
    Skill,
  },
  computed: {
    menuShown() {
      return this.$store.getters.getMenuState;
    },
  },
};
</script>

<style lang="scss">
#app-header {
  padding-top: 60px;
  background: $dark_bg;
  padding-bottom: 40px;
  transition: padding .2s ease;
  &.menuOpen {
    padding-top: 210px;
  }
  .container {
    margin-top: 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .profile_info {
      flex-basis: 65%;
      display: flex;
      flex-direction: row;
      .profile_img {
        width: 250px;
        min-width: 250px;
        height: 250px;
        box-shadow: 0 3px 6px rgba(#000, .35);
        border-radius: 2px;
      }
      .profile_desc {
        margin-left: 30px;
        h1 {
          margin: 0;
          color: $text_gray;
          font-weight: 400;
          font-size: 30px;
        }
        p {
          color: $text_gray;
          font-weight: 300;
          line-height: 1.8;
        }
        a {
          color: #0092ff;
        }
      }
    }
    .skills {
      flex-grow: 2;
      margin-left: 30px;
      h2 {
        color: $text_gray;
        font-weight: 400;
        font-size: 30px;
        margin: 0;
        text-align: center;
      }
      .skill_container {
        display: flex;
        flex-direction: column;
        padding-top: 20px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  #app-header {
    .container {
      .profile_info {
        .profile_img {
          width: 140px;
          min-width: 140px;
          max-width: 140px;
          height: 140px;
          min-height: 140px;
          max-height: 140px;
        }
        .profile_desc {
          p {
            max-width: 100%;
          }
        }
      }
      .skills {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 991px) {
  #app-header {
    .container {
      flex-direction: column;
      .profile_info {
        flex-direction: column;
        .profile_img {
          width: 200px;
          min-width: 200px;
          max-width: 200px;
          height: 200px;
          min-height: 200px;
          max-height: 200px;
          margin: 0 auto 20px;
        }
        .profile_desc {
          margin: 0 auto;
          text-align: center;
          p {
            max-width: 80%;
            margin: 10px auto 25px;
          }
        }
      }
      .skills {
        margin: 0 auto 10px;
        //width: 90%;
        width: 80%;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  #app-header {
    .container {
      .profile_info {
        .profile_img {
          width: 250px;
          min-width: 250px;
          max-width: 250px;
          height: 250px;
          min-height: 250px;
          max-height: 250px;
          margin: 0 auto 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/AppHeader.vue